export default __webpack_public_path__ + "static/media/advestAdvanclyLogo.bc9ff6a1.svg";